
import { Component, Vue } from "vue-property-decorator";

import Pagination from "@/components/Pagination/index.vue";
// 查看产品系统弹窗
import ProductSystem from "./cpns/details.vue";
// 新建/编辑表单
import NewBuild from "./cpns/newBuild.vue";
import {
  deleteProductCategory,
  disabledProductCategory,
  searchProductCategories
} from "@/api/product-business";
import {
  createProductCategory,
  editProductCategory
} from "@/api/product-category";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import {getProductManagerUser} from "@/api/users";

@Component({
  name: "ProductSystemManagement",
  components: {
    Pagination,
    ProductSystem,
    NewBuild
  }
})
export default class extends Vue {
  private tableKey = 0;
  public productCategoryList: any = [];

  private total = 0;

  configuredContainerTypes = [{ id: null, name: null, value: null }];
  private listParam = {
    managerId: null,
    name: null,
    disabled: null,
    pageNumber: 1,
    pageSize: 10
  };
  private type = "";
  private addOrEditDialogVisible = false;
  private categoryForm = {
    id: "",
    name: "",
    managerId: ""
  };
  private disabledList = [{name:"锁定",value:true},{name:"未锁定",value:false}];

  public rules = {
    name: [{ required: true, message: "请输入产品系统名称", trigger: "blur" }],
    managerId: [
      { required: true, message: "请选择产品系统经理", trigger: "change" }
    ]
  };
  private users = [];

  created() {
    this.getList();
    getProductManagerUser().then((res: any) => {
      this.users = res;
    });
  }

  private async getList() {
    const params = { ...this.listParam };
    const data: any = await searchProductCategories(params);
    this.total = data.total;
    this.productCategoryList = data.list;
  }

  private cancel() {
    this.categoryForm.name = "";
    this.categoryForm.managerId = "";
    this.addOrEditDialogVisible = false;
  }

  private editProductCategoryInit(row: any) {
    this.type = "edit";
    this.categoryForm.id = row.id;
    this.categoryForm.name = row.name;
    this.categoryForm.managerId = row.managerId;
    this.addOrEditDialogVisible = true;
  }

  async createProductCategory() {
    await createProductCategory(this.categoryForm).then(() => {
      this.addOrEditDialogVisible = false;
      this.$message({
        type: "success",
        message: "创建成功!"
      });
    });
    this.cancel();
    await this.getList();
  }

  async editProductCategory() {
    await editProductCategory(this.categoryForm.id, this.categoryForm).then(
      () => {
        this.addOrEditDialogVisible = false;
        this.$message({
          type: "success",
          message: "编辑成功!"
        });
      }
    );
    this.cancel();
    await this.getList();
  }

  private async removeProductCategory(row: any) {
    await deleteProductCategory(row.id).then(() => {
      this.$message({
        type: "success",
        message: "删除成功!"
      });
    });
    await this.getList();
  }

  private async updateProductCategoryDisabled(row: any) {
    await disabledProductCategory(row.id).then(() => {
      this.$message({
        type: "success",
        message: "操作成功!"
      });
    });
    await this.getList();
  }

  private exportExcel() {
    const data = this.productCategoryList.map((value) => {
      return {
        ...value
      };
    });
    const headers = [
      "产品系统经理",
      "产品系统名称",
      "主打产品",
      "产品经理",
      "品延产品"
    ];
    const fieldNames = [
      "managerName",
      "name",
      "flagshipQuantity",
      "managerQuantity",
      "pinYanProductQuantity"
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `产品系统管理-${new Date()}`
    );
  }
}
